import React from "react";
import { TJobData } from "../../../../store/candidate/types";
import { extractSuburbFromAddress } from "../../../../utils/stringUtils";
import CentreImage from "../../../Vacancy/CentreImage";

const VacancyDetails: React.FC<{
  vacancy: TJobData;
  type?: string;
  isCandidateFilledAllForms?: boolean;
  isMobile?: boolean;
  documentsExpired?: boolean;
  isDocumentsExpired?: boolean;
}> = ({ vacancy, type, isCandidateFilledAllForms, isMobile, documentsExpired, isDocumentsExpired }) => {
  const vacancyPositions = vacancy?.vacancyPositions?.[0] || [];
  return (
    <div className="flex-grow-1 text-break">
      <div className="d-flex gap-20">
        {type !== "view_centre" && (
          <div className="w-50px h-50px  border-2 border-grey-dark radius-40px">
            <CentreImage
              vacancy={vacancy}
              height="50px"
              width="50px"
              isCandidateFilledAllForms={isCandidateFilledAllForms}
              documentsExpired={documentsExpired}
              isDocumentsExpired={isDocumentsExpired}
            />
          </div>
        )}
        <div className="flex-grow-1 d-flex flex-row align-items-center">
          <div className="d-flex flex-column gap-3 text-black flex-wrap">
            {(isCandidateFilledAllForms && !documentsExpired && !isDocumentsExpired) ? (
              <>
                <div className="fs-13">
                  <span className="fw-700">
                    {vacancy?.centre?.business_name}
                  </span>
                  {", "}                  
                  <span>{extractSuburbFromAddress(vacancy?.centre?.address)}</span>
                  {
                    vacancy?.is_similar_match && (
                      <span className="text-grey-medium">{" (" + vacancy?.calculated_distance + " km from " + vacancy?.distance_from_suburb + ")"}</span>
                    )
                  }                  
                </div>
                {vacancyPositions?.name && (
                  <div className="fs-13">{vacancyPositions?.name}</div>
                )}
                {isMobile && (
                  <div className="fs-16">{extractSuburbFromAddress(vacancy?.centre?.address)}</div>
                )}
              </>
            ) : (
              <>
                <div className="fs-16">
                  Position in{" "}
                  <span className="fw-700">{extractSuburbFromAddress(vacancy?.centre?.address)}</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VacancyDetails;
